import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./adminUser";

export default configureStore({
  reducer: {
    user: counterReducer,
  },
});
